import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open() {
    if (window.Intercom) {
      window.Intercom("show")
    }
  }

  openWithMessage({ params: { message } }) {
    if (window.Intercom) {
      window.Intercom("showNewMessage", message)
    }
  }
}
